export default {
  title01: "Obecna Pogoda",
  title02: "24 godz.",
  title03: "Zobacz 10-dniową prognozę pogody",
  title04: "AQI",
  title05: "Zobacz wszystkie informacje",
  title06: "WSCHÓD I ZACHÓD SŁOŃCA",
  title07: "FAZA KSIĘŻYCA",
  title08: "Następna pełnia Księżyca",
  title09: "Następny nów Księżyca",
  title10: "DZIEŃ",
  title11: "NOC",
  title12: "Wschód Słońca",
  title13: "Zachód Słońća",
  title14: "Wschód Księżyca",
  title15: "Zachód Księżyca",
  title16: "Źródło",
  title17: "Początek",
  title18: "Koniec",
  title19: "Użyj obecnej lokalizacji",
  title20: "Szukaj miasta",
  title21: "Odczucie",
  title22: "Odczucie w cieniu",
  title23: "Teraz",
  title24: "Dziś",
  title25: "Niedz",
  title26: "Pon",
  title27: "Wt",
  title28: "Śr",
  title29: "Czw",
  title30: "Pt",
  title31: "Sob",
  title32: "Wczytywanie...",
  title33: "Teraz",
  title34: "Prognoza godzinowa",
  title35: "Codzienna prognoza",
  title36: "Słońce i Księżyc",
  title37: "Jakość powietrza",
  title38: "Kontakt pod adresem: xlf550402@gmail.com",
  title39: "Umowa o ochronie prywatności",
  title40: "Copyright © comfortweather.com 2020 - 2026. Wszelkie prawa zastrzeżone.",
  title41: "Dane dostarczone przez",
  title42: "Wys",
  title43: "Nis",
  title44: "Akceptuj",
  title45:
    "Dziękujemy za korzystanie z ComfortWeather! Aby lepiej chronić swoje prawa i interesy, prosimy o uważne przeczytanie ",
  title46: "Polityki prywatności",
  title47: " przed rozpoczęciem korzystania z serwisu.",
  title48: "",
  title49: "Kontakt pod adresem: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2026. Wszelkie prawa zastrzeżone.",
  title51:
    "Dziękujemy za korzystanie z 24hweather! Aby lepiej chronić swoje prawa i interesy, prosimy o uważne przeczytanie ",
  title52: "Wykryto zmianę Twojej lokalizacji. Czy chcesz ją zaktualizować?  ",
  title53: "Potwierdź ",
  title54: "Anuluj ",
  title55: "Wstecz",
  title56: "Wiadomości",
  title57: "Aktualizowanie pogody...",
  title58: "Pogoda zaktualizowana",
  title59: "Zobacz wszystkie",
  title60: "Copyright © mobi321.com 2020 - 2026. Wszelkie prawa zastrzeżone.",
  title61: "Wczoraj",
  title62: "Jutro",
  title63: "Zobacz 15-dniową prognozę pogody",
  title64: "Dzisiejsze szczegóły",
  title65: "Rahu Kaal",
  title66: "Wskaźniki stylu życia",
  title67: "Wskaźniki stylu życia",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Trudne do wysuszenia",
  title103: "Wolne suszenie",
  title104: "Dobrze się suszy",
  title105: "Szybkie suszenie",
  title106: "Bardzo szybkie suszenie",

  title107: "Niewłaściwe",
  title108: "Skromne doświadczenie",
  title109: "Dobre do zabawy w wodzie",
  title110: "Bardzo odpowiednie",
  title111: "Idealne warunki",

  title112: "Wspierające zdrowie",
  title113: "Neutralne warunki",
  title114: "Nieco wyższe ryzyko",
  title115: "Wysokie ryzyko",
  title116: "W ekstremalnym ryzyku",

  title117: "Niewłaściwe",
  title118: "Częściowo odpowiednie",
  title119: "Dobre do aktywności na świeżym powietrzu",
  title120: "Bardzo odpowiednie",
  title121: "Doskonałe warunki",

  title122: "Bardzo suche warunki",
  title123: "Prawdopodobnie suche",
  title124: "Lekko suche",
  title125: "Mało prawdopodobne, że suche",
  title126: "Bardzo mało prawdopodobne, że suche",

  title127: "Nie zalecane",
  title128: "Akceptowalne",
  title129: "Dobry dzień",
  title130: "Bardzo dobre warunki",
  title131: "Idealne warunki",
};
